
import { Inject, Injectable, DOCUMENT } from '@angular/core';


interface Scripts {
  name: string;
  src: string;
  async?: boolean;
  defer?: boolean;
}

export const ScriptStore: Scripts[] = [
  // {
  //   name: 'trustedshops',
  //   src: 'https://widgets.trustedshops.com/js/X3FD64B3D73C5DF36B6F7411AA28A3E66.js',
  // },
  {
    name: 'sequra',
    src: ''
  },
  // {
  //   name: 'trustedshopsWidgets',
  //   src: 'https://integrations.etrusted.com/applications/widget.js/v2',
  //   async: true,
  //   defer: true
  // }
];

@Injectable({
  providedIn: 'root',
})
export class ScriptService {

  scripts: any = {};

  constructor(@Inject(DOCUMENT) private document: any) {
    ScriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src
      };
    });
  }

  load(...scripts: string[]): any {
    const promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: string): any {
    return new Promise((resolve, reject) => {
      // resolve if already loaded
      if (this.scripts[name]?.loaded) {
        resolve({
          script: name,
          loaded: true,
          status: 'Already Loaded'
        });
      } else {
        // load script
        let script = this.document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.scripts[name]?.src;
        if (script.readyState) { // IE
          script.onreadystatechange = () => {
            if (script.readyState === 'loaded' || script.readyState === 'complete') {
              script.onreadystatechange = null;
              this.scripts[name] = this.scripts[name] || {};
              this.scripts[name].loaded = true;
              resolve({
                script: name,
                loaded: true,
                status: 'Loaded'
              });
            }
          };
        } else { // Others
          script.onload = () => {
            this.scripts[name] = this.scripts[name] || {};
            this.scripts[name].loaded = true;
            resolve({
              script: name,
              loaded: true,
              status: 'Loaded'
            });
          };
        }
        script.onerror = (error: any) => resolve({
          script: name,
          loaded: false,
          status: 'Loaded'
        });
        script.async = !!this.scripts[name]?.async;
        script.defer = !!this.scripts[name]?.defer;
        if (script.getAttribute('src') !== 'undefined') {
          this.document.getElementsByTagName('head')[0].appendChild(script);
        }
      }
    });
  }
}
